import { PawPrint } from "lucide-react";
import { scrollToId } from "@/lib/api";
import { SHOW_SHOP } from "@/lib/data";

export default function Footer() {
  return (
    <footer className="relative bg-pine-deep py-16 text-sand grain">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-4">
              <img src="/logo.png" alt="Wag n Tails logo" className="h-16 w-16 rounded-full object-cover ring-2 ring-gold/60" />
              <div>
                <p className="font-serif text-xl">Wag <span className="text-gold-soft italic">n</span> Tails</p>
                <p className="font-mono text-[10px] uppercase tracking-[0.28em] text-sand/50">Mountain Retreat Rescue</p>
              </div>
            </div>
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-sand/65">
              A 501(c)(3) rescue sanctuary in the mountains of Maryland. Safe haven, second chances, and a mountain to run on.
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="font-mono text-xs uppercase tracking-[0.2em] text-gold-soft">Explore</p>
            <ul className="mt-4 space-y-2.5">
              {[["Our Story", "story"], ["Animals", "animals"], ["Adopt", "adopt"], ["Volunteer", "volunteer"], ["Donate", "donate"], ["Wishlist", "wishlist"], ...(SHOW_SHOP ? [["Shop", "merch"]] : [])].map(([label, id]) => (
                <li key={id}>
                  <button data-testid={`footer-link-${id}`} onClick={() => {
                    if (window.location.pathname !== "/") { window.location.href = "/#" + id; setTimeout(() => scrollToId(id), 300); } else scrollToId(id);
                  }} className="text-sm text-sand/70 hover:text-gold-soft transition-colors">
                    {label}
                  </button>
                </li>
              ))}
              <li>
                <a data-testid="footer-link-tributes" href="/tributes" className="text-sm text-sand/70 hover:text-gold-soft transition-colors">Rescue Tributes</a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="font-mono text-xs uppercase tracking-[0.2em] text-gold-soft">Reach the mountain</p>
            <ul className="mt-4 space-y-2.5 font-mono text-sm text-sand/70">
              <li>donate4pawz@gmail.com</li>
              <li>(301) 723-0010</li>
              <li>Maryland mountains</li>
              <li>EIN 87-0992741</li>
            </ul>
            <a data-testid="footer-admin-link" href="/admin" className="mt-5 inline-flex items-center gap-2 text-xs font-mono uppercase tracking-widest text-sand/40 hover:text-gold-soft transition-colors">
              <PawPrint className="h-3.5 w-3.5" /> Staff / Admin Portal
            </a>
          </div>
        </div>

        <div className="mt-12 border-t border-sand/10 pt-6 flex flex-col sm:flex-row justify-between gap-3">
          <p className="font-mono text-[11px] text-sand/40">© {new Date().getFullYear()} Wag n Tails Mountain Retreat Rescue. Demo contact details — swap in your real info.</p>
          <p className="font-mono text-[11px] text-sand/40">Secure payments powered by Stripe · every dollar goes to the animals.</p>
        </div>
      </div>
    </footer>
  );
}
